import { useMount } from 'react-nb-hooks'
import { useLoading } from 'loankeeper-common/components/hocs/LazyLoading'

export const LoadingIndicator = () => {
  const loadingProvider = useLoading()

  useMount(() => {
    loadingProvider.startLoading()
    return loadingProvider.stopLoading
  })

  return null
}
